<template>
    <v-menu v-model="dateFilterPicker" :close-on-content-click="false" transition="scale-transition">
        <template v-slot:activator="{props}">
            <v-btn color="primary" variant="text" size="small" class="pa-0" v-bind="props">
                <v-icon size="small">mdi-calendar</v-icon>
                {{ `${$t('tours.more_dates')} ...` }}
            </v-btn>
        </template>
        <!-- eslint-disable vue/no-custom-modifiers-on-v-model -->
        <vc-date-picker
            v-if="isShowDatePicker"
            v-model.string="selectedDate"
            :masks="masks"
            :locale="$i18n.locale"
            :attributes="showPriceDuringSearch ? attributes : []"
            :min-date="availableDates.start"
            :max-date="availableDates.end"
            :color="isAvailable"
            :first-day-of-week="$conf.public.firstDayOfWeek || undefined"
            is-required
            @input="onDateChange"
        >
            <template v-slot:day-popover="{attributes}">
                <div v-for="attr in attributes" :key="attr.key">
                    {{ $filters.price(attr.customData.price) }}
                </div>
            </template>
        </vc-date-picker>
    </v-menu>
</template>

<script lang="ts">
    import {Component, Prop, Setup, VModel, Vue} from 'vue-facing-decorator'

    @Component
    export class TourDateFilter extends Vue {
        @VModel() selectedDate
        @Prop({required: true}) offers
        @Setup(() => useBookingPriceButton().showPriceDuringSearch) showPriceDuringSearch

        dateFilterPicker = false
        isShowDatePicker = true

        onDateChange() {
            //v-calendar bug bypass
            this.isShowDatePicker = false

            this.$nextTick(() => {
                this.isShowDatePicker = true
            })
        }

        get masks() {
            return {modelValue: 'YYYY-MM-DD'}
        }

        get isAvailable() {
            return this.attributes?.find(attr => attr.dates === this.selectedDate).highlight.color
        }

        get availableDates() {
            const dates = this.uniqueDaysOffersWithMinPrice
                .map(item => item.info.packageDate)
                .sort((a, b) => new Date(a) - new Date(b))
            const startDate = dates[0]
            const endDate = dates[dates.length - 1]
            return {start: startDate, end: endDate}
        }

        get uniqueDaysOffersWithMinPrice() {
            const sortedOffers = clone(this.offers)?.sort((a, b) => a.price.amount - b.price.amount)
            return Array.from(new Set(sortedOffers.map(item => item.info.packageDate))).map(date =>
                sortedOffers.find(item => item.info.packageDate === date)
            )
        }

        get attributes() {
            return this.uniqueDaysOffersWithMinPrice.reduce((attributes, offer, index) => {
                const isSelectedDay = this.selectedDate === this.$dateFns.format(offer.info.packageDate)
                const isAvailable = offer.entries.every(entry =>
                    entry.type === 'ACCOMMODATION'
                        ? entry.offers?.[0]?.rooms.every(room => room.available)
                        : entry.offers?.[0]?.available
                )
                const data = {
                    dates: this.$dateFns.format(offer.info.packageDate),
                    key: `day-${index}`,
                    highlight: {
                        color: isAvailable ? 'green' : 'orange',
                        fillMode: isSelectedDay ? 'solid' : 'outline',
                        class: 'opacity-75',
                        contentStyle: {
                            color: 'inherit',
                            fontWeight: 500,
                        },
                    },
                    popover: {
                        visibility: 'hover',
                    },
                    customData: offer,
                }
                attributes.push(data)

                return attributes
            }, [])
        }
    }

    export default TourDateFilter
</script>

<style lang="scss" scoped>
    .date-field {
        max-width: 160px;
    }

    :deep(.vc-highlight) {
        border-width: 1px !important;
    }
</style>
